import styled from 'styled-components'
import { BLACK, GRAYSCALE_500 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-family: ${INTER.regular};
  color: ${BLACK};
`

export const Title = styled.span`
  font-family: ${INTER.semiBold};
  color: ${GRAYSCALE_500};
`

export const Value = styled.span`
  font-family: ${INTER.regular};
`

export const BoldValue = styled.span`
  font-family: ${INTER.bold};
`
